export default (response, json) =>
  Promise.reject({
    message: `Fetch request failed with status: ${json.Status}`,
    response,
    json
  });
